import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'

const ButtonLoadingComponent: React.FC = () => {
  return <CircularProgress size={24} color={'secondary'} sx={{ ml: 2 }} />
}

export default ButtonLoadingComponent
